import * as React from 'react';
import { Form, Button, Icon, Input, Row, Col, notification, Select } from 'antd';
import { FormComponentProps, ValidationRule } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router';
import { StyleUpdateUserProfileForm, OneSpanColLayout, InputColLayout, ButtonColLayout, ReadOnlyColLayout } from './UpdateUserProfileForm.Style';
import { UpdateUserProfileFormHandler } from './UpdateUserProfileFormHandler';
import {
  IndividualConsigneePartialUpdateModel1,
  IndividualConsigneeReturnModel,
  IIndividualConsigneeReturnModel,
} from 'Core/Api/UserManagement/Api';
import AuthContext from 'Context/AuthContext';
import FormControl from 'components/Forms/FormControl';
import MaskedInput from 'components/Forms/MaskedInput';
import FormUtility from 'Core/FormUtility';
import NotificationUtility from 'Core/NotificationUtility';
import { SubmitButton } from 'components/SubmitButton';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {
  userProfile: IIndividualConsigneeReturnModel;
}

class BaseUpdateUserProfileForm extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  updateUserProfileFormHandler: UpdateUserProfileFormHandler;
  _isMounted: boolean | undefined;

  constructor(props: Props) {
    super(props);
    this.updateUserProfileFormHandler = new UpdateUserProfileFormHandler();
    this.displayUserDetails = this.displayUserDetails.bind(this)
    this.state = {
      userProfile: {},
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({})
    this.displayUserDetails(); //brings back user details to display as default values
  }

  handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll(
      (error, values: IndividualConsigneePartialUpdateModel1) => {
        if (!error) {
          //Set TRN value so that update goes through
          if (this.state.userProfile.tRN !== undefined) {
            // this.state.userProfile.map(trn => (values.tRN = trn.tRN!));
            values.tRN = this.state.userProfile.tRN
          }

          this.updateUserProfileFormHandler
            .UpdateUserProfile(values)
            .then(() => {
              NotificationUtility.success('Success', 'Profile Update was successful', 10, true);
            })
            .catch(x => {
              NotificationUtility.error('Error While Updating Profile', x.message ?? x, 30, true);
            });
        }
      }
    );
  }

  async displayUserDetails() {
    if (this.context.data?.umaid !== undefined) {
      await this.updateUserProfileFormHandler
        .RequestGetUserProfile()
        .then(profile => {
          console.log(this.context.data?.username)
          console.log('profile', profile)

          this.setState({ userProfile: profile });
          console.log('state userprofile', this.state.userProfile)

        })
        .catch(x => {
          NotificationUtility.error('Error', 'No Results found', 15, true);
        });
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { Option } = Select;
    const profile = this.state.userProfile

    const nameValidation: ValidationRule[] = [
      { required: true, message: 'Please enter both your first and last names' },
      { max: 30, message: 'Limit of 30 characters' },
    ];

    const mobilenumberValidation: ValidationRule[] = [
      { required: true, message: 'Please enter a mobile number' },
      { pattern: /[0-9]{3}-[0-9]{3}-[0-9]{4}/, message: 'Please enter valid Mobile Number' },
    ];

    const addressValidation: ValidationRule[] = [
      { required: true, message: 'Please enter an address' },
      { max: 255, message: 'You have character limit' },
    ];


    const profileInfo =
      <>
        <Row type='flex' justify='center'>
          <Col span={20} offset={2} >
            <Form onSubmit={this.handleSubmit} layout="vertical" >

              <Row style={{ marginBottom: '25px' }} gutter={10}>

                <Col {...InputColLayout}>
                  <Row type='flex' justify='center' gutter={10} align="top">
                    <Col span={8}>
                      <FormControl
                        getFieldDecorator={getFieldDecorator}
                        label="Email"
                        name="email"
                        initialValue={profile.primaryUserEmailAddress}>
                        <Input
                          prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          disabled
                        />
                      </FormControl>
                    </Col>
                    <Col span={8}>
                      <FormControl
                        getFieldDecorator={getFieldDecorator}
                        label="TRN"
                        name="trn"
                        initialValue={profile.tRN}>
                        <Input
                          prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          disabled
                        />
                      </FormControl>
                    </Col>
                    <Col span={8}>
                      <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={mobilenumberValidation}
                        label="Mobile Number"
                        name="mobilePhoneNumber"
                        initialValue={profile.mobilePhoneNumber}>
                        <MaskedInput
                          prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          mask="999-999-9999"
                          alwaysShowMask={true}
                          className="Sumperess"
                          placeholder="Mobile Number"
                        />
                      </FormControl>
                    </Col>
                  </Row>
                </Col>

                <Col {...InputColLayout}>
                  <Row type='flex' justify='center' gutter={10} align="top">
                    <Col span={12}>
                      <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={nameValidation}
                        label="First Name"
                        name="firstName"
                        initialValue={profile.firstName}>
                        <Input
                          prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          placeholder={profile.firstName}
                        />
                      </FormControl>
                    </Col>
                    <Col span={12}>
                      <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={nameValidation}
                        label="Last Name"
                        name="lastName"
                        initialValue={profile.lastName}>
                        <Input
                          prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          placeholder="Last Name"
                        />
                      </FormControl>
                    </Col>
                  </Row>
                </Col>

                <Col {...InputColLayout}>
                  <Row type='flex' justify='center' gutter={10} align="top">
                    <Col span={12}>
                      <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={addressValidation}
                        label="Address Line 1"
                        name="addressLine1"
                        initialValue={profile.addressLine1}>
                        <Input
                          prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          placeholder="Address Line 1"
                        />
                      </FormControl>
                    </Col>
                    <Col span={12}>
                      <FormControl
                        getFieldDecorator={getFieldDecorator}
                        label="Address Line 2"
                        name="addressLine2"
                        initialValue={profile.addressLine2}>
                        <Input
                          prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          placeholder="Address Line 2"
                        />
                      </FormControl>
                    </Col>
                  </Row>
                </Col>

                <Col {...InputColLayout}>
                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[{ required: true, message: 'Please select a Parish' }]}
                    name="parish"
                    label="Parish"
                    initialValue={profile.parish}>
                    {FormUtility.parishSelector()}
                  </FormControl>
                </Col>
              </Row>
              <Row>
                <Col {...ButtonColLayout}>
                  <Form.Item>
                    <SubmitButton type="primary" htmlType="submit" style={{ textAlign: "center" }}>Update Profile</SubmitButton>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </>

    return (
      <>
        {this.state.userProfile ?
          profileInfo :
          <p></p>
        }
      </>

    );
  }
}

const UpdateUserProfileFormWithoutRouter = Form.create<Props>({
  name: 'UpdateUserProfileForm',
})(BaseUpdateUserProfileForm);

const UpdateUserProfileForm = withRouter(UpdateUserProfileFormWithoutRouter);

export default UpdateUserProfileForm;
